import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepShell from '@/components/StepShell';
import Ornament from '@/components/Ornament';
import { useSession } from '@/store/session';

/**
 * Pantalla OPCIONAL: el cliente puede meter un perfume que ya usa.
 * Si lo rellena, en Result aparecerá una sección extra con perfumes del catálogo
 * Elixir SIMILARES por overlap de notas Fragantica.
 *
 * Si lo salta → no afecta nada, continúa el flujo normal.
 */
export default function MyPerfume() {
  const navigate = useNavigate();
  const { client, setClient } = useSession();
  const [value, setValue] = useState(client.favoritePerfume ?? '');

  const saveAndNext = (val: string | undefined) => {
    setClient({ favoritePerfume: val });
    navigate('/mouillettes');
  };

  return (
    <StepShell
      step={5}
      title="¿Tienes ya un perfume favorito?"
      subtitle="Opcional. Si nos dices cuál, te buscamos algo parecido en el catálogo."
      onBack={() => navigate('/preferencias')}
      onNext={() => saveAndNext(value.trim() || undefined)}
      nextDisabled={false}
      nextLabel="Continuar"
    >
      <Ornament />

      <div className="max-w-2xl mx-auto mt-6">
        <label className="block text-sm font-medium text-elixir-gold-soft mb-2">
          Marca + nombre del perfume que más usas
        </label>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="ej. Lattafa Khamrah, Creed Aventus, Tom Ford Tobacco Vanille…"
          className="w-full px-4 py-3 rounded-lg bg-black/40 border border-elixir-gold/30 text-white placeholder-white/30 focus:outline-none focus:border-elixir-gold transition"
          autoComplete="off"
          spellCheck={false}
        />
        <p className="text-xs text-white/40 mt-2">
          Cuanto más exacto, mejor (incluye la marca). Si no usas perfume habitualmente, pulsa Saltar.
        </p>

        <div className="flex gap-3 mt-8">
          <button
            type="button"
            onClick={() => saveAndNext(undefined)}
            className="flex-1 px-6 py-3 rounded-lg border border-white/20 text-white/70 hover:bg-white/5 transition"
          >
            Saltar este paso
          </button>
        </div>
      </div>
    </StepShell>
  );
}
